import { PublicMeetingType } from '@chilipiper/api-client/src/meeting-types'
import { MeetingAttemptResponseV2, NotFound1 } from '@chilipiper/api-client/src/user-availability'
import {
  TeamSchedulingApiClientV1,
  TeamSchedulingApiClientV2,
} from '@chilipiper/api-client/src/team-scheduling'
import {
  MeetingLimitSource,
  getMeetingLimit,
} from '../../load-availability-options/helpers/meeting-host-limit'

export const getLinkMeetingLimitFromMeetingAttempt = async (
  tenantId: string,
  teamSchedulingClientV1: TeamSchedulingApiClientV1,
  teamSchedulingClientV2: TeamSchedulingApiClientV2,
  meetingAttempt?: Exclude<
    MeetingAttemptResponseV2,
    {
      type: 'NotFound'
    } & NotFound1
  >,
  meetingType?: PublicMeetingType
): Promise<MeetingLimitSource> => {
  if (meetingAttempt?.attempt.productFeature.type === 'AdminIndividualSchedulingLink') {
    const schedulingLink =
      await teamSchedulingClientV1.findAAdminSchedulingLinkByAdminSchedulingLinkIdPublic(
        tenantId,
        meetingAttempt.attempt.productFeature.linkId
      )

    return getMeetingLimit({
      linkInfo: schedulingLink,
      type: 'AdminSchedulingLink',
      id: meetingAttempt.attempt.productFeature.linkId,
    })
  }

  if (meetingAttempt?.attempt.productFeature.type === 'PersonalIndividualSchedulingLink') {
    return getMeetingLimit({
      linkInfo: meetingType,
      type: 'PersonalSchedulingLink',
      id: meetingAttempt.attempt.productFeature.meetingTypeId,
    })
  }

  if (meetingAttempt?.attempt.productFeature.type === 'GroupSchedulingLink') {
    const groupSchedulingLink =
      await teamSchedulingClientV2.findAGroupSchedulingLinkByGroupSchedulingLinkIdPublicV2(
        tenantId,
        meetingAttempt.attempt.productFeature.linkId
      )

    return getMeetingLimit({
      linkInfo: groupSchedulingLink,
      type: 'GroupSchedulingLink',
      id: meetingAttempt.attempt.productFeature.linkId,
    })
  }

  return {
    type: 'NoMeetingLimit' as const,
  }
}
